import { Box, Dialog, Typography } from "@mui/material";
import { styled, keyframes } from '@mui/system';

export const ConfettiContainer = styled(Box)({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '100px',
    overflow: 'hidden',
    pointerEvents: 'none',
});

export const Confetti = styled('div')(({ theme }) => ({
    position: 'absolute',
    width: '10px',
    height: '10px',
    background: '#A68AFF',
    opacity: 0.7,
    animation: '$fall 3s linear infinite',
    '&:nth-of-type(2n)': {
        background: '#FC3E58',
    },
    '&:nth-of-type(3n)': {
        background: '#A68AFF',
    },
    '@keyframes fall': {
        '0%': { transform: 'translateY(-100px) rotate(0deg)' },
        '100%': { transform: 'translateY(100vh) rotate(360deg)' },
    },
}));

export const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        borderRadius: '16px',
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background?.paper,
        fontFamily: 'walsheim',
    },
}))

export const AnimatedTypography = styled(Typography)(({ theme }) => ({
    animation: '$countUp 2s ease-out',
    '@keyframes countUp': {
        '0%': {
            opacity: 0,
            transform: 'translateY(20px)',
        },
        '100%': {
            opacity: 1,
            transform: 'translateY(0)',
        },
    },
}));


const rocketFly = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(1100%);
  }
`;


const smokeAnimation = keyframes`
  0% {
    transform: scale(0.5);
    opacity: 0.3;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
`;

export const RocketContainer = styled(Box)({
    position: 'absolute',
    top: '20px',
    left: '-50px',
    width: '50px',
    height: '50px',
    animation: `${rocketFly} 5s linear`,
    zIndex: 10,
  })


 export const Smoke = styled('div')({
    position: 'absolute',
    top: '50%',
    left: '0',
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: 'rgba(200, 200, 200, 0.3)',
    animation: `${smokeAnimation} 0.8s ease-out`,
  })


 export const Rocket = () => (
    <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.13 22.19L11.5 18.36C13.07 17.78 14.54 17 15.9 16.09L13.13 22.19ZM5.64 12.5L1.81 10.87L7.91 8.1C7 9.46 6.22 10.93 5.64 12.5ZM21.61 2.39C21.61 2.39 16.66 .269 11 5.93C8.81 8.12 7.5 10.53 6.65 12.64C6.37 13.39 6.56 14.21 7.11 14.77L9.24 16.89C9.79 17.45 10.61 17.63 11.36 17.35C13.5 16.53 15.88 15.19 18.07 13C23.73 7.34 21.61 2.39 21.61 2.39ZM14.54 9.46C13.76 8.68 13.76 7.41 14.54 6.63S16.59 5.85 17.37 6.63C18.14 7.41 18.15 8.68 17.37 9.46C16.59 10.24 15.32 10.24 14.54 9.46Z"/>
    </svg>

  )